module.exports = __webpack_public_path__ + "media/images/ponce_battery_potencia-307fdb0a.jpeg";